import { createContext, useState } from "react"
import { scrollUpTo } from "utils/scrollUpTo"

export const PaginationContext = createContext({})

const PaginationProvider = (props) => {
	const [page, setPage] = useState(0)
	const [rowsPerPage, setRowsPerPage] = useState(25)

	const handleChangePage = (event, newPage) => {
		setPage(newPage)
	}

	// const handleChangeRowsPerPage = (event) => {
	// 	console.log("check", event.target.value)
	// 	// setRowsPerPage(parseInt(event.target.value, rowsPerPage))
	// 	setRowsPerPage(parseInt(event.target.value))
	// 	setPage(0)
	// 	// scrollUpTo(0)
	// }

	return (
		<PaginationContext.Provider
			value={{
				page,
				setPage,

				rowsPerPage,
				setRowsPerPage,

				handleChangePage
				// handleChangeRowsPerPage
			}}
			{...props}
		/>
	)
}

export default PaginationProvider
